import React, { useEffect, useMemo, useCallback } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { SignInService, DataSourceMmgService } from "../services/index";
import { useDempStore } from "src/context/stores";
import dayjs from "dayjs";

const useDataSourceMng = () => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const [plantId, companyId, updateCompanyId, updatePlantId] = useDempStore((state) => [
    state.plantId,
    state.companyId,
    state.updateCompanyId,
    state.updatePlantId,
  ]);

  const [state, setState] = React.useState({
    tab: localStorage.getItem("tab-ds") || "data_source",
    mode: queryParams.get("mode"),
    server: {
      name: "images",
      display_name: "Images",
    },
    historyDetailImage: null,
    selectServer: null,
    Select_model: [
      {
        id: 1,
        name: "General Model",
        value: "general",
      },
      {
        id: 2,
        name: "g2.s",
        value: "g2-s"
      },
      {
        id: 3,
        name: "g2.m",
        value: "g2-m"
      },
      {
        id: 4,
        name: "Fleetcard Model",
        value: "fleetcard",
      },
      {
        id: 5,
        name: "Electricity Model",
        value: "electricity",
      },
      {
        id: 6,
        name: "Water Model",
        value: "water",
      }
    ],
    active_date: dayjs().format("YYYY-MM"),
    self_upload_type: "bill",
    configId: "",
    transaction_id: queryParams.get("id") || null,
    transection_details_id: null,
    servers: [],
    select_year: {
      id: 2,
      cycle: 2025,
    },
    invoice_id: "",
    paginationModel: { page: 0, pageSize: 10 },
    years: [],
    buildings: [],
    input_types: [],
    folders: [],
    setup_servers: [],
    status: [],
    setup_details: [],
    overview_status: [],
    devices: {},
    bill: {
      message: "",
      url: "",
    },
    settings: {
      url: "",
    },
    dialog: {
      add_server: false,
      select_server: false,
      add_device: false,
      device_details: false,
      confirm_add_server: true,
      loading_sync_onedrive: false,
      upload_transaction: false,
      settings: false,
    },
    history: [],
    tansactionById: [],
    historyDetail: null,
    model: "general",
    files: [],
    alert: {
      open: false,
      message: "Authentication failed, Please try again later.",
      severity: "error",
    },
    loading: {
      modal: true,
      isLoadingCreateAsset: false,
      folder: false,
      card: false,
    },
    warning: {
      open: false,
      warningTitle: "Are you sure you want to delete these data sources?",
      warningText: undefined,
      okBtnText: "Yes, Delete",
      cancelBtnText: "Cancel",
      severity: "warning",
      handleOkClicked: null,
      handleCancle: null,
      shouldRefetch: false,
    },
    serverConfig: [],
  });

  const handleConfirmCreate = () => {
    setState((prevState) => ({
      ...prevState,
      warning: {
        ...prevState.warning,
        open: false,
      },
      dialog: {
        ...prevState.dialog,
        add_server: true,
      },
      loading: {
        modal: true,
      },
    }));
    fetchConfigure();
  };

  const handleCancle = () => {
    setState((prevState) => ({
      ...prevState,
      warning: {
        open: false,
      },
    }));
  };

  const SyncDataSource = async (code) => {
    const dsString = Cookies.get("ds");
    const ds = dsString ? JSON.parse(dsString) : null;

    const SignInOneDriveService = new SignInService();
    try {
      const config = {
        body: {
          code,
          plant: plantId,
          platform: ds?.name,
          service: "drive",
        },
      };
      const response = await SignInOneDriveService.syncDataSource(config);
      if (response.status === 200 || response.status === 201) {
        navigate("/data-source-mng");
        setState((prevState) => ({
          ...prevState,
          selectServer: response.data,
          dialog: {
            ...prevState.dialog,
            loading_sync_onedrive: false,
          },
          warning: {
            open: true,
            warningTitle: "Do you want to Add configure?",
            warningText: undefined,
            okBtnText: "Yes, Add configure",
            cancelBtnText: "Cancel",
            severity: "info",
            handleCancle: () => {
              fetchDataSource();
              handleCancle();
              Cookies.remove("ds");
            },
            handleOkClicked: () => handleConfirmCreate(),
          },
        }));
      }
    } catch (error) {
      console.log(error);
      Cookies.remove("ds");
      setState((prevState) => ({
        ...prevState,
        dialog: {
          ...prevState.dialog,
          loading_sync_onedrive: false,
        },
        warning: {
          open: true,
          warningTitle: error?.status === 400 ? error?.message : null,
          warningText:
            error?.status === 400 ? null : error?.response?.data?.message,
          okBtnText: null,
          cancelBtnText: "Close",
          severity: "error",
          handleCancle: () => {
            handleCancle();
            navigate("/data-source-mng");
          },
          handleOkClicked: null,
        },
      }));
    }
  };

  const fetchHistory = async (id) => {
    const DataSourceMng = new DataSourceMmgService();
    setLoading("modal", true);

    try {
      const config = {
        id,
      };

      const response = await DataSourceMng.getHistory(config);
      if (response.status === 200) {
        setState((prevState) => ({
          ...prevState,
          transaction_id: response.data?.id,
          history: response.data?.details,
          tansactionById: response.data,
          loading: {
            ...prevState.loading,
            modal: response.data?.details?.length === 0 ? true : false,
          },
          ...(state.mode === 'liff' && {
            dialog: {
              ...prevState.dialog,
              device_details: true,
            },
          }),
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading("modal", false);
    }
  };

  const fetchHistoryDetail = async (id) => {
    const DataSourceMng = new DataSourceMmgService();
    setLoading("modal", true);

    try {
      const config = {
        id,
      };
      // console.log('config', config)

      const response = await DataSourceMng.getHistoryDetail(config);

      if (response.status === 200) {
        setState((prevState) => ({
          ...prevState,
          historyDetail: response.data,
          loading: {
            ...prevState.loading,
            modal: response.data?.details?.length === 0 ? true : false,
          },
        }));
      } else {
        setAlert({
          open: true,
          message: "Error fetching history detail",
          severity: "error",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading("modal", false);
    }
  };

  const setTransactionId = (id) => {
    setState(prev => ({
      ...prev,
      transactionId: id
    }));
  };

  const calculateWaterMeter = async (id) => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        id,
      };
      const response = await DataSourceMng.calculateWaterMeter(config);
      if (response.status === 200 || response.status === 201) {
        setAlert({
          open: true,
          message: "Water meter calculated successfully",
          severity: "success",
        });
      }
    } catch (error) {
      console.log(error);
      if(error.response.status === 400){
        setAlert({
          open: true,
          message: error.response.data.message,
          severity: "error",
        });
      }
    }
  };

  const updateHistoryDetail = async (data) => {
    const DataSourceMng = new DataSourceMmgService();
    setLoading("modal", true);

    try {
      const config = {
        body: data.data,
        id: data.id,
      };

      const response = await DataSourceMng.updateHistoryDetail(config);

      if (response.status === 200 || response.status === 201) {
        setAlert({
          open: true,
          message: "History detail updated successfully",
          severity: "success",
        });
        fetchHistory(state.transaction_id);

        // Close dialog and reset history state
        // setState((prev) => ({
        //   ...prev,
        //   dialog: {
        //     ...prev.dialog,
        //     device_details: false,
        //   },
        //   history: [],
        //   historyDetail: null,
        // }));
      }
    } catch (error) {
      console.log(error.response);
      setAlert({
        open: true,
        message: error.response.status === 500 ? error.response.statusText : (error.response.status === 400) ? error.response.data.error : "Error updating history detail",
        severity: "error",
      });
    } finally {
      setLoading("modal", false);
    }
  };

  const updateTransactionDetails = async (data) => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        body: data,
        id: state.transection_details_id,
      };

      const response = await DataSourceMng.updateTransactionDetails(config);
      if (response.status === 200 || response.status === 201) {
        setAlert({
          open: true,
          message: "Transaction details updated successfully",
          severity: "success",
        });

        fetchHistoryDetail(state.transection_details_id);
      }
    }
    catch (error) {
      if(error.response.status === 400){
        setAlert({
          open: true,
          message: error.response.data.message,
          severity: "error",
        });
      }
    }
  };

  const updateDetailsWasteTravelling = async (data, id) => {
    const DataSourceMng = new DataSourceMmgService();
    setLoading("modal", true);

    try {
      const config = {
        body: data,
        id: id,
      };

      const response = await DataSourceMng.updateDetailsWasteTravelling(config);

      if (response.status === 200 || response.status === 201) {
        setAlert({
          open: true,
          message: "Details updated successfully",
          severity: "success",
        });
        fetchHistory(state.transaction_id);
      }
    } catch (error) {
      console.log(error.response);
      setAlert({
        open: true,
        message: error.response?.status === 500 ? error.response.statusText : (error.response?.status === 400) ? error.response.data.error : "Error updating details",
        severity: "error",
      });
    } finally {
      setLoading("modal", false);
    }
  };

  const exportTransactionFile = async (transaction_id) => {
    const DataSourceMng = new DataSourceMmgService();

    try {
      
      const response = await DataSourceMng.exportTransactionFile({id: transaction_id});
      // console.log(response)

      if (response.status === 200) {
        return response;
      } else {
        return null;
      }
    } catch (error) {
      console.log(error);
      return null;
    } finally {
      setLoading("modal", false);
    }
  };

  const fetchAliasTransaction = async () => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        params: { 
          plant_id: plantId,
          company_id: companyId, 
        },
      };
      const response = await DataSourceMng.aliasTransaction(config);
      // console.log('response', response)
      if (response.status === 200) {
        return response.data;
      } else {
        return null;
      }
    }
    catch (error) {
      console.log(error);
      return null;
    }
  };

  const registerServer = async (data) => {
    const DataSourceMng = new DataSourceMmgService();
    // Store current selected server before any operation
    const currentSelectServer = state.selectServer;
    
    try {
      const config = {
        body: data,
      };

      const response = await DataSourceMng.registerServer(config);
      if (response.status === 200 || response.status === 201) {
        setAlert({
          open: true,
          message: "Successfully registered server",
          severity: "success",
        });
        await fetchDataSource();
        setState((prevState) => ({
          ...prevState,
          selectServer: currentSelectServer,
          loading: {
            ...prevState.loading,
            card: false,
          },
        }));
      }
    }
    catch (error) {
      console.log(error);
      // Always close loading state when error occurs and restore selected server
      setState((prevState) => ({
        ...prevState,
        selectServer: currentSelectServer, // Restore the selected server
        loading: {
          ...prevState.loading,
          card: false,
        },
      }));
      
      // Fetch device data to show existing data in table
      try {
        await fetchDevice();
      } catch (fetchError) {
        console.log('Error fetching device data:', fetchError);
      }
      
      if(error.response?.status === 400){
        setAlert({
          open: true,
          message: 'Failed to register server. Please try again later.',
          severity: "error",
        });
      } else {
        setAlert({
          open: true,
          message: 'An error occurred. Please try again later.',
          severity: "error",
        });
      }
    }
  };

  const deleteTransaction = async (data) => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        id: data.id,
      };

      const response = await DataSourceMng.deleteTransaction(config);
      if (response.status === 200 || response.status === 204) {
        setAlert({
          open: true,
          message: "Transaction deleted successfully",
          severity: "success",
        });
        await fetchDevice();
      }
    } catch (error) {
      console.log(error);
      setAlert({
        open: true,
        message: error.response?.status === 400 
          ? error.response.data?.error || "Failed to delete transaction" 
          : error.response?.status === 500 
          ? error.response.statusText 
          : "Error deleting transaction",
        severity: "error",
      });
    }
  };

  const uploadTransaction = async () => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        body: {
          files: state?.files,
          plant_id: plantId,
          company_id: companyId,
          active_date: state.active_date,
          model: state.model,
        },
      };

      const response = await DataSourceMng.uploadTransaction(config);
      if (response.status === 200 || response.status === 201) {
        setState((prevState) => ({
          ...prevState,
          loading: {
            ...prevState.loading,
            modal: false,
          },
          warning: {
            ...prevState.warning,
            open: true,
            warningTitle: "Loading file...",
            warningText:
              "The file will appear in the list once loading is complete.",
            okBtnText: "OK",
            cancelBtnText: null,
            severity: "success",
            handleOkClicked: async () => {
              setState((prevState) => ({
                ...prevState,
                files: [],
                shouldRefetch: true,
                dialog: {
                  ...prevState.dialog,
                  upload_transaction: false,
                },
                warning: {
                  ...prevState.warning,
                  open: false,
                },
              }));

              await fetchDataSource();

              // fetch device
              const DataSourceMng = new DataSourceMmgService();
              const deviceConfig = {
                params: {
                  server_code: state.selectServer?.code?.toLowerCase(),
                  company_id: companyId,
                  page: 1,
                  invoice_id: "",
                  type: state.selectServer?.code?.toLowerCase() === "huawei" ? "iot" : state.self_upload_type,
                },
              };
              const deviceResponse = await DataSourceMng.getDevices(deviceConfig);
                if (deviceResponse.status === 200) {
                  setState((prev) => ({
                    ...prev,
                    devices: deviceResponse.data,
                    loading: {
                      ...prev.loading,
                      card: false,
                    },
                  }));
                }
              },
          },
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataBill = async () => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        params: {},
      };

      const response = await DataSourceMng.getBill(config);
      // console.log(response.data);
      if (response.status === 200) {
      }
    } catch (error) {
      // console.log(error);
      setState((prevState) => ({
        ...prevState,
        bill: {
          message: "ERR ...",
          url: "https://picsum.photos/seed/picsum/200/300",
        },
      }));
      if (error.status === 404) {
        setState((prevState) => ({
          ...prevState,
          bill: {
            message: "ERR ...",
            url: "https://picsum.photos/seed/picsum/200/300",
          },
        }));
      }
    }
  };

  const fetchDataSource = async () => {

    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        params: {
          company_id: companyId,
          plant_id: plantId,
        },
      };

      const response = await DataSourceMng.getDataSource(config);
      if (response.status === 200) {
        const data = response?.data || [];
        setState((prevState) => ({
          ...prevState,
          selectServer: state.mode === 'liff' ? data[1] ?? {} : data[0] ?? {},
          servers: response.data,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchServerConfig = async (code) => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        params: {
          code: code,
          company_id: companyId,
          plant_id: plantId,
        },
      };
      const response = await DataSourceMng.getServerConfig(config);
      if (response.status === 200) {
        setState((prevState) => ({
          ...prevState,
          serverConfig: response.data,
        }));
      } else {
        return null;
      }
    } catch (error) {
      if (error.response?.status === 502) {
        setAlert({
          open: true,
          message: "Server is temporarily unavailable. Please try again later.",
          severity: "error",
        });
      } else if (error.response?.status >= 500) {
        setAlert({
          open: true,
          message: "Server error occurred. Please try again later.",
          severity: "error",
        });
      } else if (error.response?.status === 404) {
        setState((prevState) => ({
          ...prevState,
          serverConfig: null,
        }));
      }
      return null;
    }
  };

  const syncNow = async (serverId, folderUrl) => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        id: serverId,
        body: {
          folder_url: folderUrl
        }
      };
      const response = await DataSourceMng.syncNow(config);
      // console.log('response', response);
      if (response.status === 200) {
        setAlert({
          open: true,
          message: "Data source synced successfully",
          severity: "success",
        });
        fetchDataSource();
        fetchServerConfig(state.selectServer?.code);
      } else {
        setAlert({
          open: true,
          message: response.data.error || "Failed to sync data source",
          severity: "error",
        });
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  const fetchDevice = useCallback(async () => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        params: {
          server_code: state.selectServer?.code.toLowerCase(),
          company_id: companyId,
          page: state.paginationModel?.page + 1,
          invoice_id: state.invoice_id,
          // type: state.self_upload_type,
          type: state.selectServer?.code.toLowerCase() === "huawei" ? "iot" : state.self_upload_type,
        },
      };

      const response = await DataSourceMng.getDevices(config);
      if (response.status === 200) {
        setState((prevState) => ({
          ...prevState,
          devices: response.data,
          loading: {
            ...prevState.loading,
            card: false,
          },
        }));
      }
    } catch (error) {
      console.log(error);
    }
  }, [
    state.paginationModel,
    state.selectServer?.name,
    companyId,
    state.invoice_id,
    state.self_upload_type,
  ]);

  const fetchConfigure = async (cycle) => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        params: {
          id: state.selectServer?.id,
          cycle: cycle?.id || state.select_year?.id,
        },
      };

      const response = await DataSourceMng.getConfigures(config);
      if (response.status === 200) {
        setState((prevState) => ({
          ...prevState,
          setup_details: response.data,
          loading: {
            ...prevState.dialog,
            modal: false,
          },
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDirectory = async (folderId) => {
    setState((prevState) => ({
      ...prevState,
      folders: [],
      loading: {
        ...prevState.loading,
        folder: true,
      },
    }));
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        params: {
          userId:
            state.selectServer?.source_id || state.selectServer?.source_id,
          platform: "microsoft",
          folderId,
        },
      };
      if (!folderId) {
        delete config.params.folderId;
      }
      const response = await DataSourceMng.getDirectories(config);
      if (response.status === 200) {
        setState((prevState) => ({
          ...prevState,
          folders: response.data,
          loading: {
            ...prevState.loading,
            folder: false,
          },
        }));
      }
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        folders: [],
      }));
    }
  };

  const fetchInputType = async () => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        params: {},
      };

      const response = await DataSourceMng.getInputTypes(config);

      if (response.status === 200) {
        setState((prevState) => ({
          ...prevState,
          input_types: response.data,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBuilding = async () => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        params: {
          plant: plantId,
        },
      };

      const response = await DataSourceMng.getbuildings(config);
      if (response.status === 200) {
        setState((prevState) => ({
          ...prevState,
          buildings: response.data,
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchYears = async () => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        params: {},
      };

      const response = await DataSourceMng.getYears(config);
      if (response.status === 200) {
        setState((prevState) => ({
          ...prevState,
          years: response.data,
        }));
      }
    } catch (error) {
      console.log(error);
      if (error.status === 404) {
        setState((prevState) => ({
          ...prevState,
          years: [],
        }));
      }
    }
  };

  const fetchServers = async () => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        params: {
          plant: Cookies.get("plantId"),
        },
      };

      const response = await DataSourceMng.getServers(config);
      if (response.status === 200) {
        setState((prevState) => ({
          ...prevState,
          setup_servers: response.data?.results,
          loading: {
            ...prevState.loading,
            modal: false,
          },
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setTab = (tab) => {
    setState((s) => ({
      ...s,
      tab: tab,
    }));
  };

  const setDialog = (key, value) => {
    setState((s) => ({
      ...s,
      dialog: {
        ...s.dialog,
        [key]: value,
      },
    }));
  };

  const setLoading = (key, value) => {
    setState((s) => ({
      ...s,
      loading: {
        ...s.loading,
        [key]: value,
      },
    }));
  };

  const setAlert = (value) => {
    setState((s) => ({
      ...s,
      alert: value,
    }));
  };

  const Add_Server = async (config_body) => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        body: {
          id: state.selectServer?.id,
          cycle: state.select_year?.id,
          config: config_body,
        },
      };
      const response = await DataSourceMng.createConfig(config);
      if (response.status === 200 || response.status === 201) {
        fetchDataSource();
        setState((prevState) => ({
          ...prevState,
          loading: {
            ...prevState.loading,
            modal: false,
          },
          setup_details: {
            ...prevState.setup_details,
            results: response?.data?.map((v) => {
              return {
                ...v?.config,
                status: v?.status,
              };
            }),
          },
        }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchAsset = async (transactionId) => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        id: transactionId,
      };

      const response = await DataSourceMng.getAssets(config);
      return response.data;
      // if (response.status === 200) {
      //   setState((prevState) => ({
      //     ...prevState,
      //     assets: response.data,
      //   }));
      // }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchEmissions = async () => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const response = await DataSourceMng.getEmissions();
      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  const CreateAsset = async (config_body) => {
    const DataSourceMng = new DataSourceMmgService();
    setLoading("isLoadingCreateAsset", true);

    try {
      const config = {
        body: config_body,
      };

      const response = await DataSourceMng.createAsset(config);

      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        warning: {
          ...prevState.warning,
          open: false,
        },
      }));
    } finally {
      setLoading("isLoadingCreateAsset", false);
    }
  };

  const assignFirstMonth = async (id) => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        id,
      };
      const response = await DataSourceMng.assignFirstMonth(config);
      if (response.status === 200 || response.status === 201) {
        fetchHistory(state.transaction_id);
        fetchHistoryDetail(id);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const Remove_Server = async () => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        body: {
          id: state.selectServer?.id,
        },
      };

      const response = await DataSourceMng.removeDataSource(config);
      if (response.status === 200) {
        setState((prevState) => ({
          ...prevState,
          isRemove: false,
          selectServer: null,
          warning: {
            ...prevState.warning,
            open: false,
          },
          alert: {
            open: true,
            message: "Data source successfully deleted.",
            severity: "success",
          },
        }));
        fetchDataSource();
      }
    } catch (error) {
      console.log(error);
      setState((prevState) => ({
        ...prevState,
        isRemove: false,
        selectServer: null,
        warning: {
          ...prevState.warning,
          open: false,
        },
        alert: {
          open: true,
          message: error?.message,
          severity: "error",
        },
      }));
    }
  };

  const Remove_Config = async (id) => {
    const DataSourceMng = new DataSourceMmgService();
    try {
      const config = {
        body: {
          id,
        },
      };

      const response = await DataSourceMng.removeConfig(config);
      if (response.status === 200) {
        setState((s) => ({
          ...s,
          warning: {
            ...s.warning,
            open: false,
          },
          loading: {
            ...s.loading,
            modal: false,
          },
        }));
      }
    } catch (error) {
      console.log(error);
      setState((s) => ({
        ...s,
        warning: {
          ...s.warning,
          open: false,
        },
        loading: {
          ...s.loading,
          modal: false,
        },
      }));
    }
  };

  const setPaginationModel = (model) => {
    setState((s) => ({
      ...s,
      paginationModel: model,
    }));
  };

  const fetchServerOptions = React.useCallback(() => {
    fetchDataSource();
  }, []);

  // const fetchAllDevice = React.useCallback(() => {
  //     fetchDevice(state.selectServer?.name, state.paginationModel);
  // }, [state.selectServer?.name, state.paginationModel]);

  //   useEffect(() => {
  //     const code = queryParams.get("code");
  //     if (code) {
  //       setDialog("loading_sync_onedrive", true);
  //       SyncDataSource(code);
  //     }
  //     // fetchAllData();
  //     fetchDevice();
  //     return () => {
  //       localStorage.setItem("tab-ds", state.tab);
  //     };
  //   }, [fetchDevice]);

  useEffect(() => {
    if (state.mode === 'liff') {
      updateCompanyId(queryParams.get("companyId"));
      updatePlantId(queryParams.get("plantId"));
      if (state.transaction_id) {
        fetchHistory(state.transaction_id);
      }
    }
  }, [state.mode, state.transaction_id]);

  useEffect(() => {
    if (companyId) {
      fetchServerOptions();
    }
  }, [companyId]);

  useEffect(() => {
    if (!!state.selectServer) {
      fetchDevice();
    }
  }, [fetchDevice, state.selectServer]);

  const ctx = React.useMemo(() => {
    return {
      companyId,
      mode: state.mode,
      historyDetailImage: state.historyDetailImage,
      selectServer: state.selectServer,
      select_year: state.select_year,
      servers: state.servers,
      folders: state.folders,
      buildings: state.buildings,
      input_types: state.input_types,
      setup_servers: state.setup_servers,
      setup_details: state.setup_details,
      transactionId: state.transaction_id,
      overview_status: state.overview_status,
      transection_details_id: state.transection_details_id,
      status: state.status,
      devices: state.devices,
      dialog: state.dialog,
      loading: state.loading,
      isRemove: state.isRemove,
      configId: state.configId,
      alert: state.alert,
      warning: state.warning,
      bill: state.bill,
      settings: state.settings,
      years: state.years,
      tab: state.tab,
      files: state.files,
      history: state.history,
      tansactionById: state.tansactionById,
      model: state.model,
      Select_model: state.Select_model,
      self_upload_type: state.self_upload_type,
      active_date: state.active_date,
      historyDetail: state.historyDetail,
      serverConfig: state.serverConfig,
      updateHistoryDetail,
      paginationModel: state.paginationModel,
      setTab: setTab,
      setDataState: setState,
      setDialog,
      setLoading,
      Add_Server,
      Remove_Server,
      Remove_Config,
      fetchHistory,
      fetchHistoryDetail,
      fetchBuilding,
      fetchInputType,
      fetchDirectory,
      fetchServers,
      fetchDevice,
      fetchYears,
      fetchDataBill,
      fetchConfigure,
      fetchAsset,
      fetchEmissions,
      CreateAsset,
      setPaginationModel,
      uploadTransaction,
      updateTransactionDetails,
      updateDetailsWasteTravelling,
      fetchDataSource,
      assignFirstMonth,
      setTransactionId,
      calculateWaterMeter,
      registerServer,
      deleteTransaction,
      exportTransactionFile,
      fetchAliasTransaction,
      fetchServerConfig,
      syncNow
    };
  }, [state]);

  return ctx;
};

export default useDataSourceMng;
